export enum ActorType {
    Player,
    Flowerpot,
    Vase,
    Bee,
    Bud,
    Plant,
    LetterPlant,
    WateringCan
}